import { render } from "./company-sons.vue?vue&type=template&id=91e27de6&scoped=true"
import script from "./company-sons.vue?vue&type=script&lang=js"
export * from "./company-sons.vue?vue&type=script&lang=js"

import "./company-sons.vue?vue&type=style&index=0&id=91e27de6&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91e27de6"]])

export default __exports__